import { useState } from 'react';
import { Container, Switch, withStyles } from "@material-ui/core";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header/Header";
import SimpleBottomNavigation from "./components/MainNav";
import Movies from "./Pages/Movies/Movies";
import Search from "./Pages/Search/Search";
import Series from "./Pages/Series/Series";
import Trending from "./Pages/Trending/Trending";
import { red } from "@material-ui/core/colors";

function App() {
  const [lightMode, setlightMode] = useState(false);
  const DarkMode = withStyles({
    switchBase: {
      color: red[300],
      '&$checked': {
        color: red[500],
      },
      '&$checked + $track': {
        backgroundColor: red[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);
  
  return (
    <BrowserRouter>
      
      <Header lightMode={lightMode}/> 

      <div className="app" style={{
         backgroundColor: lightMode ?'#131111' :'rebeccapurple',
         color: lightMode ? "gold": "white",
          transition: "all 0.5s linear",}}>
         <div style={{position: 'absolute', top: 0, right: 15, paddingTop: 120}}>
         <DarkMode  checked={lightMode}  onChange={() => setlightMode(!lightMode)}/>
        </div>
        <Container>
          <Routes>
          <Route exact path="/" element={<Trending />} />
          <Route exact path="/movies" element={<Movies />} />
          <Route exact path="/series" element={<Series />} />
          <Route exact path="/search" element={<Search />} />

            {/* <Route path="/movies"><Movies /></Route>
            <Route path="/series"><Series /></Route>
            <Route path="/search"><Search /></Route> */}
          </Routes>
        </Container>
      </div>
      <SimpleBottomNavigation />
    </BrowserRouter>
  );
}

export default App;